var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-scrollbar",
    { staticClass: "side-scroll-bar", style: { height: _vm.scrollerHeight } },
    [
      _c(
        "div",
        { staticClass: "panel-container" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "no-bottom-margin indent-left-margin",
              model: {
                value: _vm.firstTab,
                callback: function ($$v) {
                  _vm.firstTab = $$v
                },
                expression: "firstTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { name: "componentLib" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(_vm._s(_vm.i18nt("designer.componentLib"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-collapse",
                    {
                      staticClass: "widget-collapse",
                      model: {
                        value: _vm.activeNames,
                        callback: function ($$v) {
                          _vm.activeNames = $$v
                        },
                        expression: "activeNames",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            name: "1",
                            title: _vm.i18nt("designer.containerTitle"),
                          },
                        },
                        [
                          _c(
                            "draggable",
                            {
                              attrs: {
                                tag: "ul",
                                list: _vm.containers,
                                chosenClass: "chosen",
                                group: {
                                  name: "dragGroup",
                                  pull: "clone",
                                  put: false,
                                },
                                clone: _vm.handleContainerWidgetClone,
                                "ghost-class": "ghost",
                                sort: false,
                                move: _vm.checkContainerMove,
                                animation: "100",
                              },
                              on: { end: _vm.onContainerDragEnd },
                            },
                            _vm._l(_vm.containers, function (ctn, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  staticClass: "container-widget-item",
                                  attrs: { title: ctn.name },
                                  on: {
                                    dblclick: function ($event) {
                                      return _vm.addContainerByDbClick(ctn)
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "line1" }, [
                                    _vm._v(_vm._s(ctn.name)),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.crudList, function (item, index) {
                        return _c(
                          "el-collapse-item",
                          {
                            attrs: {
                              name: (index + 2).toString(),
                              title: item.table_name,
                            },
                          },
                          [
                            _c(
                              "draggable",
                              {
                                attrs: {
                                  tag: "ul",
                                  list: item.field,
                                  group: {
                                    name: "dragGroup",
                                    pull: "clone",
                                    put: false,
                                  },
                                  move: _vm.checkFieldMove,
                                  clone: _vm.handleFieldWidgetClone,
                                  "ghost-class": "ghost",
                                  sort: false,
                                  animation: "100",
                                },
                              },
                              _vm._l(item.field, function (fld, index) {
                                return _c(
                                  "li",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !_vm.designer.selectNames.includes(
                                            fld.options.name
                                          ),
                                        expression:
                                          "!designer.selectNames.includes(fld.options.name)",
                                      },
                                    ],
                                    key: index,
                                    staticClass: "field-widget-item line1",
                                    attrs: { title: fld.name },
                                    on: {
                                      dblclick: function ($event) {
                                        return _vm.addFieldByDbClick(fld)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "line1" }, [
                                      _vm._v(_vm._s(fld.name)),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }